import React from 'react';
import './EventsSelector.scss';
import { IEventsSelectorProps } from './IEventsSelectorProps';
import PerfectScrollbar from 'react-perfect-scrollbar';
// import { ReactComponent as SearchIcon } from '../channelSelector/icons/searchicon.svg';
import AppLoader from 'components/contentLoaders/appLoader';
import { EventsService } from 'api/services/events';
import useDelayDebounceEffect from 'hooks/useDelayDebounceEffect';
import miscUtils from 'utils/miscUtils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const EventsSelector: React.FC<IEventsSelectorProps> = (props) => {

  const [loadingEvents, setLoadingEvents] = React.useState<boolean>(true);
  const [events, setEvents] = React.useState<Array<any>>([]);

  useDelayDebounceEffect(() => {
    if(props.courseLessonVariant) {
      getAvaialbleEventsForCourses(true);
    } else {
      getEvents(true);
    }
  }, [props.searchString], 500);

  const getEvents = (noLoad?: boolean) => {
    let query: string = '?when=upcoming&published=true';
    if (props.searchString.length) {
      query = `${query}&search=${props.searchString}`;
    }
    if(!noLoad) {
        setLoadingEvents(true);
    }
    EventsService.getInstance()
      .getAllEvents(props.group.id, query)
      .then((response: any) => {
        setLoadingEvents(false);
        let apiEvents: Array<any> = [];
        Object.keys(response.data.data).forEach((period: any) => {
            apiEvents = [...apiEvents, ...response.data.data[period]];
        });
        setEvents(apiEvents);
      })
      .catch((error: any) => {
        console.error(error)
        new Error(error)
      })
      .finally(() => setLoadingEvents(false));
  };

  const getAvaialbleEventsForCourses = (noLoad?: boolean) => {
    let query: string = '';

    if(props.searchString.length) {
      query = `?search=${props.searchString}`;
    }

    if(!noLoad) {
      setLoadingEvents(true);
    }

    EventsService.getInstance()
      .getAvailableEventsForCourses(props.group.id, query)
      .then((response: any) => {
        setLoadingEvents(false);
        setEvents(response.data);
      })
      .catch((error: any) => {
        console.error(error)
        new Error(error)
      })
      .finally(() => setLoadingEvents(false));
  }

  const dateIsInCurrentYear = (date: any) => {
    return dayjs.utc(date).tz(miscUtils.getCommunityTimezone(props.group)).isSame(dayjs().tz(miscUtils.getCommunityTimezone(props.group)), 'year');
  }

  return (
    <div className="events-selector-container">
        {loadingEvents ? (
          <div
          className="events-selector-loading-container"
          >
              <AppLoader
              label="Loading events..."
              />
          </div>
        ) : (
            <>
            {/* <div className="channel-selector-search-container">
                <input
                className="channel-selector-search-input"
                placeholder="Add available collection"
                type="text"
                value={searchString}
                onChange={(e: any) => setSearchString(e.target.value)}
                />
                <span
                className="channel-selector-search-icon"
                onClick={() => getCollections(true)}
                >
                    <SearchIcon />
                </span>
            </div> */}
            <div className="events-selector-events-container">
              {events.filter((event: any) => !(props.selectedEvent && props.selectedEvent.id === event.id)).length === 0 ? (
                <div className="events-selector-empty-container">
                  <p className="events-selector-empty-text">No results found</p>
                </div>
              ) : (
                <PerfectScrollbar
                className="events-selector-events-scrollarea"
                options={{
                    wheelPropagation: false,
                }}
                >
                    {events.filter((event: any) => !(props.selectedEvent && props.selectedEvent.id === event.id)).map((event: any) => {
                      return (
                        <div
                        className="events-selector-event-container"
                        onClick={() => props.onEventSelected(event)}
                        >
                        <p className="events-selector-event-name">{event.title}</p>
                        <p
                        className="events-selector-event-date"
                        >
                          {dayjs.utc(event.start_time).tz(miscUtils.getCommunityTimezone(props.group)).format(`ddd, MMM DD${dateIsInCurrentYear(event.start_time) ? '' : ' YYYY'}`)}
                        </p>
                        </div>
                    )})}
                </PerfectScrollbar>
              )}
            </div>
            </>
        )}
    </div>
  )
}

export default EventsSelector;